<form [formGroup]="municipalityInformationForm" *ngIf="municipalityConfig$ | async as municipalityConfig">
  <mat-card>
    <mat-card-content class="full-width">
      <div class="top-container">
        <div class="top-inside-container">
          <div class="form-group-top">
            <label class="label">
              {{ 'module.userProfile.generalInformation.collectivityLabelText' | translate }}
            </label>
            <ng-container *ngIf="!isGemisDSO; else multiSelectDropdown">
              <app-dropdown class="app-dropdown" *ngIf="isSystemAdmin" [value]="selectedRegion" [autoClose]="true">
                <app-dropdown-option
                  class="dropdown-option"
                  *ngFor="let region of municipalityConfig.regionAssignment.data"
                  [value]="region.name"
                  (optionSelect)="selectRegion(region)"
                >
                  {{ region.name }}
                </app-dropdown-option>
              </app-dropdown>
            </ng-container>

            <ng-template #multiSelectDropdown>
              <app-dropdown
                id="multiSelectDropdown"
                class="app-dropdown"
                *ngIf="isSystemAdmin"
                [value]="selectedRegion"
                [autoClose]="true"
                [isMultipleSelect]="true"
              >
                <app-dropdown-option class="dropdown-option" *ngFor="let region of regionAssignment" [value]="region.name">
                  <mat-checkbox [checked]="region.selected" (change)="selectRegion(region)">{{ region.name }}</mat-checkbox>
                </app-dropdown-option>
              </app-dropdown>
            </ng-template>
            <div class="administrative-title" *ngIf="!isSystemAdmin">
              {{ selectedRegion }}
            </div>
          </div>

          <div class="form-group-top">
            <label class="label">{{ 'module.userProfile.generalInformation.municipalityKeyLabelText' | translate }}</label>
            <mat-form-field class="form-field">
              <input title="municipalityKey" class="input" [value]="municipalityConfig.municipality.municipalityKey" disabled matInput autocomplete="off" />
            </mat-form-field>
          </div>
        </div>
        <div class="top-inside-container">
          <div class="form-group-top">
            <label class="label">{{ 'module.userProfile.generalInformation.municipalityLabelText' | translate }}</label>
            <div class="form-field">
              <mat-form-field class="mat-form-field">
                <input title="municipalityLabel" class="input" formControlName="name" matInput autocomplete="off" maxlength="250" />
              </mat-form-field>
              <span *ngIf="isFormInvalid('name')" class="error-message">{{
                'module.userProfile.generalInformation.municipalityNameRequiredText' | translate
              }}</span>
            </div>
          </div>

          <div class="form-group-top">
            <label class="label">{{ 'module.userProfile.generalInformation.zipCodeLabelText' | translate }}</label>
            <mat-form-field class="mat-form-field">
              <input title="zipCode" class="input" formControlName="zipCode" matInput autocomplete="off" maxlength="5" (keypress)="numberOnly($event)" />
            </mat-form-field>
            <span *ngIf="isFormInvalid('zipCode')" class="error-message">
              {{ 'module.userProfile.generalInformation.zipCodeRequiredText' | translate }}
            </span>
          </div>
        </div>
      </div>

      <div class="toggle-container">
        <div class="toggle-inside-container">
          <mat-slide-toggle
            [disabled]="!authService.permissions.GENERAL_CONFIGURATION_UPDATE"
            class="isActiveToggle"
            formControlName="isDeactivated"
            (change)="deactivateChangeHandler()"
            labelPosition="before"
          >
          </mat-slide-toggle>
          <span class="tooltiptext">{{ 'module.userProfile.generalConfiguration.tooltipText' | translate }}</span>
          <label class="label">Kommune deaktivieren</label>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
